import {
  BabaSpecialOffer,
  BagelCodeSpecialOffer,
  BanditosSpecialOffer,
  BingoPopSpecialOffer,
  CashFrenzySpecialOffer,
  CashmanCasinoSpecialOffer,
  ClassicVegasSlotsSpecialOffer,
  DecaSpecialOffer,
  DefaultStudioSpecialOffer,
  DrimageSpecialOffer,
  FabelTownSpecialOffer,
  GennmuSpecialOffer,
  HugeSpecialOffer,
  JunesJourneySpecialOffer,
  LoadCompleteSpecialOffer,
  LocoBingoSpecialOffer,
  MatchMastersSpecialOffer,
  MightyFuSpecialOffer,
  PipaSpecialOffer,
  PokerFaceSpecialOffer,
  ProductMadnessSpecialOffer,
  SpinXSpecialOffer
} from '@appcharge/shared-ui';
import { ESpecialOfferInternalViewModel } from 'constants/enums';

import { EThemes } from '../enums';

import { PromotionDesignsMetadata } from './types';

const dynamic: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.STUDIO_DEFAULT,
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: 'Dynamic Offer',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_default_subs.png',
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_default_main.png',
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_default_main_sub.png'
  ],
  maxSupportedProducts: 1000,
  component: DefaultStudioSpecialOffer
};

// todo: remove!!!!!!!
// const defaultHuuugeNew: PromotionDesignsMetadata = {
//   id: 'huuuge-new',
//   theme: EThemes.HUUUGE,
//   version: '1.0.0',
//   name: 'Huuuge',
//   createdAt: '2025-10-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [
//     'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_subs.png',
//     'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_main.png',
//     'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_main_sub.png'
//   ],
//   maxSupportedProducts: 1000,
//   component: HugeSpecialOffer
// };

const defaultHuuuge: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.HUGE,
  theme: EThemes.HUUUGE,
  version: '1.0.0',
  name: 'Huuuge',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_huuugee.png'
  ],
  maxSupportedProducts: 1000,
  component: HugeSpecialOffer
};

const defaultMatchMasters: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.MATCH_MASTERS,
  theme: EThemes.CANDIVORE,
  version: '1.0.0',
  name: 'Match Masters',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 50,
  component: MatchMastersSpecialOffer
};

const defaultPokerFace: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.POKER_FACE,
  theme: EThemes.COMMUNIX,
  version: '1.0.0',
  name: 'Poker Face',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 4,
  component: PokerFaceSpecialOffer
};

const defaultBagelcode: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BAGELCODE,
  theme: EThemes.BAGELCODE,
  version: '1.0.0',
  name: 'Bagelcode',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 4,
  component: BagelCodeSpecialOffer
};

const defaultLocobingo: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.LOCO_BINGO,
  theme: EThemes.LOCO_BINGO,
  version: '1.0.0',
  name: 'Loco Bingo',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 2,
  component: LocoBingoSpecialOffer
};

// const defaultMe2on: PromotionDesignsMetadata = {
//   id: ESpecialOfferInternalViewModel.ME2ON,
//   theme: EThemes.ME2ON,
//   version: '1.0.0',
//   name: 'Me2on',
//   createdAt: '2025-08-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [],
//   maxSupportedProducts: 1,
//   component: Me2onSpecialOffer
// };

const defaultPipa: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.PIPA,
  theme: EThemes.PIPA,
  version: '1.0.0',
  name: 'Pipa',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 4,
  component: PipaSpecialOffer
};

const defaultJackpotSlots: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.JACKPOT_SLOTS,
  theme: EThemes.PM_Franchise,
  version: '1.0.0',
  name: 'Product Madness Franchise',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_jms.png'
  ],
  maxSupportedProducts: 20,
  component: ProductMadnessSpecialOffer
};

const defaultBigFishCasino: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BIG_FISH_CASINO,
  theme: EThemes.PM_Franchise,
  version: '1.0.0',
  name: 'Big Fish Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_bfc.png'
  ],
  maxSupportedProducts: 10,
  component: ProductMadnessSpecialOffer
};

const defaultMightyFu: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.MIGHTY_FU,
  theme: EThemes.MIGHTY_FU_CASINO,
  version: '1.0.0',
  name: 'Mighty Fu',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_mfc.png'
  ],
  maxSupportedProducts: 10,
  component: MightyFuSpecialOffer
};

const defaultBaba: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BABA,
  theme: EThemes.BABA,
  version: '1.0.0',
  name: 'Baba',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 9,
  component: BabaSpecialOffer
};

// const defaultPlaySimple: PromotionDesignsMetadata = {
//   id: ESpecialOfferInternalViewModel.PLAY_SIMPLE,
//   theme: EThemes.PLAY_SIMPLE,
//   version: '1.0.0',
//   name: 'Play Simple',
//   createdAt: '2025-08-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [],
//   maxSupportedProducts: 1,
//   component: PlaySimpleSpecialOffer
// };

const defaultGhost: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.GHOST,
  theme: EThemes.GHOST,
  version: '1.0.0',
  name: 'Ghost',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 2,
  component: ClassicVegasSlotsSpecialOffer
};

const defaultBingoPop: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BINGO_POP,
  theme: EThemes.BINGO_POP,
  version: '1.0.0',
  name: 'Bingo Pop',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 7,
  component: BingoPopSpecialOffer
};

const defaultFabelTown: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.FABEL_TOWN,
  theme: EThemes.FABEL_TOWN,
  version: '1.0.0',
  name: 'Fabel Town',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 10,
  component: FabelTownSpecialOffer
};

const defaultDeca: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.DECA,
  theme: EThemes.DECA,
  version: '1.0.0',
  name: 'Deca',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 40,
  component: DecaSpecialOffer
};

const defaultLoadComplete: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.LOAD_COMPLETE,
  theme: EThemes.LOAD_COMPLETE,
  version: '1.0.0',
  name: 'Load Complete',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 10,
  component: LoadCompleteSpecialOffer
};

const defaultSpinX: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.SPIN_X,
  theme: EThemes.SPIN_X,
  version: '1.0.0',
  name: 'Spin X',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 4,
  component: SpinXSpecialOffer
};

const defaultCashFrenzy: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.CASH_FRENZY,
  theme: EThemes.CASH_FRENZY,
  version: '1.0.0',
  name: 'Cash Frenzy',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 5,
  component: CashFrenzySpecialOffer
};

const defaultGennmu: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.GENNMU,
  theme: EThemes.GENNMU,
  version: '1.0.0',
  name: 'Gennmu',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 1,
  component: GennmuSpecialOffer
};

const defaultBanditos: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BANDITOS,
  theme: EThemes.BANDITOS,
  version: '1.0.0',
  name: 'Banditos',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 8,
  component: BanditosSpecialOffer
};

const defaultJunesJourney: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.JUNES_JOURNEY,
  theme: EThemes.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_wooga.png'
  ],
  maxSupportedProducts: 8,
  component: JunesJourneySpecialOffer
};

const defaultDrimage: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.DRIMAGE,
  theme: EThemes.DRIMAGE,
  version: '1.0.0',
  name: 'Drimage',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxSupportedProducts: 1,
  component: DrimageSpecialOffer
};

const defaultCashmanCasino: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.CASHMAN_CASINO,
  theme: EThemes.CASHMAN_CASINO,
  version: '1.0.0',
  name: 'Cashman Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_cmc.png'
  ],
  maxSupportedProducts: 1,
  component: CashmanCasinoSpecialOffer
};

export const promotionDesigns = {
  defaultHuuuge,
  // defaultHuuugeNew,
  defaultMatchMasters,
  defaultPokerFace,
  defaultBagelcode,
  defaultLocobingo,
  defaultPipa,
  defaultJackpotSlots,
  defaultBigFishCasino,
  defaultMightyFu,
  defaultBaba,
  defaultGhost,
  defaultBingoPop,
  defaultFabelTown,
  defaultDeca,
  defaultLoadComplete,
  defaultSpinX,
  defaultCashFrenzy,
  defaultBanditos,
  defaultJunesJourney,
  defaultDrimage,
  defaultGennmu,
  dynamic,
  defaultCashmanCasino
};

export const promotionDesignsByTheme: Record<
  EThemes,
  PromotionDesignsMetadata[]
> = Object.values(promotionDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, PromotionDesignsMetadata[]>
);

export const promotionDesignsById: Record<string, PromotionDesignsMetadata> =
  Object.values(promotionDesigns).reduce(
    (acc, design) => {
      acc[design.id as string] = design;
      return acc;
    },
    {} as Record<string, PromotionDesignsMetadata>
  );
